export const TruthSocialIcon = () => (
  <svg
    tabIndex={-1}
    focusable="false"
    className="svg-icon icon-truth-social"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="primary-path"
      tabIndex={-1}
      d="M2.5 3.045H8.034V7.896H2.5ZM21.5 7.897V3.045H10.206V20.955H15.971V7.897Z"
      fill="#27292D"
    />
  </svg>
);
